var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreferredIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5524",
    "data-name": "Group 5524",
    transform: "translate(-1400.078 -344)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2593",
    "data-name": "Rectangle 2593",
    width: 16,
    height: 17,
    rx: 2,
    transform: "translate(1400.078 344)",
    fill: "#afdbe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13407",
    "data-name": "Path 13407",
    d: "M-3.211-9.113A3.125,3.125,0,0,1-1.7-8.762,2.474,2.474,0,0,1-.7-7.768,2.987,2.987,0,0,1-.338-6.292a2.772,2.772,0,0,1-.37,1.443,2.524,2.524,0,0,1-1.04.968,3.32,3.32,0,0,1-1.541.344H-5.135a.057.057,0,0,0-.065.065V-.156a.15.15,0,0,1-.045.111A.15.15,0,0,1-5.356,0H-6.877a.15.15,0,0,1-.111-.046.15.15,0,0,1-.045-.111v-8.8a.15.15,0,0,1,.045-.111.15.15,0,0,1,.111-.045Zm-.273,4.108a1.342,1.342,0,0,0,.962-.345,1.187,1.187,0,0,0,.364-.9,1.224,1.224,0,0,0-.364-.923,1.327,1.327,0,0,0-.962-.351H-5.135a.057.057,0,0,0-.065.065V-5.07a.057.057,0,0,0,.065.065Z",
    transform: "translate(1412.078 357)",
    fill: "#33a3b1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferredIcon);
export default __webpack_public_path__ + "static/media/preferred-icon.d29c7954.svg";
export { ForwardRef as ReactComponent };